/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.1
 */

import produce from 'immer';
import { Reducer } from 'redux';

import {
    LOAD_LIST_INQUIRIES_FAIL,
    LOAD_LIST_INQUIRIES_REQUEST,
    LOAD_LIST_INQUIRIES_SUCCESS,
    LOAD_LIST_ORDERS_FAIL,
    LOAD_LIST_ORDERS_REQUEST,
    LOAD_LIST_ORDERS_SUCCESS,
} from './widgetOrderInquiriesConstants';
import { IWidgetOrderInquiriesReducer, TWidgetOrderInquiriesAction } from './widgetOrderInquiriesTypes';

export const widgetOrderInquiryInitialState: IWidgetOrderInquiriesReducer = {
    errorOrder: '',
    errorInquiries: '',
    orders: [],
    inquiries: [],
    loadingOrder: true,
    loadingInquiries: true,
};

const widgetOrderInquiriesReducer: Reducer<IWidgetOrderInquiriesReducer, TWidgetOrderInquiriesAction> =
    (
        state: IWidgetOrderInquiriesReducer = widgetOrderInquiryInitialState,
        action: TWidgetOrderInquiriesAction,
    ) =>
        produce(state, draft => {
            switch (action.type) {
                case LOAD_LIST_ORDERS_REQUEST:
                    draft.loadingOrder = true;
                    draft.errorOrder = widgetOrderInquiryInitialState.errorOrder;
                    draft.orders = widgetOrderInquiryInitialState.orders;
                    break;
                case LOAD_LIST_ORDERS_SUCCESS:
                    draft.loadingOrder = false;
                    draft.orders = action.payload;
                    break;
                case LOAD_LIST_ORDERS_FAIL:
                    draft.errorOrder = action.payload;
                    draft.loadingOrder = false;
                    break;
                case LOAD_LIST_INQUIRIES_REQUEST:
                    draft.loadingInquiries = true;
                    draft.errorInquiries = widgetOrderInquiryInitialState.errorInquiries;
                    draft.inquiries = widgetOrderInquiryInitialState.inquiries;
                    break;
                case LOAD_LIST_INQUIRIES_SUCCESS:
                    draft.loadingInquiries = false;
                    draft.inquiries = action.payload;
                    break;
                case LOAD_LIST_INQUIRIES_FAIL:
                    draft.errorInquiries = action.payload;
                    draft.loadingInquiries = false;
                    break;
            }
        });

export default widgetOrderInquiriesReducer;
